import HorizontalNavList from "@components/horizontal-nav-list";
import * as React from 'react';
export default {
  HorizontalNavList,
  React
};